import React from 'react';
import cx from 'classnames';
import * as styles from './OMRadioButtonItem.scss';

const OMRadioButtonItem = (properties) => {
  const { element, details, params: { name, checked, onChange, value, isAgent, isMobile }, parameters } = properties;
  return (
    <div
      className={cx(
        properties.className,
        styles.packageWrapper,
        { [styles.checked]: checked },
        { [styles.publisherPackageWrapper]: !isAgent }
      )}
      {...parameters}
    >
      <label htmlFor={value} className={styles.packageHeader}>
        <div className="radio">
          <label htmlFor={value}>
            <input
              name={name}
              type="radio"
              value={value}
              id={value}
              checked={checked}
              onChange={onChange}
            />
            <span />
            {(isMobile)
              ? (
                <div className={styles.mobileContent}>
                  {element.properties}
                  {element.highlight}
                </div>
              )
              : (<span>{element.properties}</span>)
            }
          </label>
          {!isMobile && element.highlight}
        </div>
        {properties.children}
      </label>
      {checked && details}
    </div>
  );
};

export default OMRadioButtonItem;
